// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2j29P","header":"MergedInvoice_header__3gw9o"};